@if (showBanner()) {
  @if (matchingStep(); as step) {
    <div
      class="border-primary-200 bg-primary-50 flex flex-col gap-1 border border-solid p-2"
      [class.border-warn-200]="stepStore.isOverdue()"
      [class.bg-warn-50]="stepStore.isOverdue()"
      [class.border-success-200]="stepStore.isComplete()"
      [class.bg-success-50]="stepStore.isComplete()"
    >
      @if (matchingSteps().length > 1) {
        <div class="flex items-center gap-1 px-2">
          @for (step of matchingSteps(); track step.id; let index = $index) {
            <button
              #stepPillOrigin="cdkOverlayOrigin"
              cdkOverlayOrigin
              type="button"
              class="flex items-center gap-1 rounded-full border px-2 py-0.5 text-xs font-medium transition-colors"
              [ngClass]="{
                'border-primary-500 bg-primary-100 text-primary-700':
                  selectedStepIndex() === index && !isStepComplete(step),
                'border-gray-300 bg-white text-gray-600 hover:bg-gray-100':
                  selectedStepIndex() !== index && !isStepComplete(step),
                'border-success-300 bg-success-50 text-success-700 pointer-events-none opacity-60':
                  isStepComplete(step)
              }"
              (click)="selectStep(index)"
            >
              @if (step.status === 'complete') {
                <mat-icon class="icon-xs text-success-600"
                  >check_circle</mat-icon
                >
              }
              <span class="truncate" [textContent]="step.title"></span>
            </button>
            <pt-custom-tooltip
              tooltipDelay="short"
              [target]="stepPillOrigin"
              [positions]="tooltipPositions"
            >
              <ng-template ptCustomTooltipContent>
                <div
                  class="flex max-w-sm flex-col gap-1 whitespace-pre-line p-3"
                >
                  <span class="text-xs font-semibold">{{ step.title }}</span>
                  <span class="text-xs opacity-80">
                    <pr-content-view [content]="step.description" />
                  </span>
                </div>
              </ng-template>
            </pt-custom-tooltip>
          }
        </div>
      }
      <div class="flex items-center justify-between gap-2 px-2">
        <div class="flex min-w-0 flex-1 items-center gap-2">
          <h4
            class="!m-0 truncate text-sm font-semibold"
            [textContent]="step.title"
          ></h4>
          @if (stepStore.stepProgress(); as progress) {
            <span
              #progressOrigin="cdkOverlayOrigin"
              cdkOverlayOrigin
              class="text-primary-700 bg-primary-100 rounded px-2 py-0.5 text-xs font-semibold"
              >{{ stepStore.getStepProgressLabel() }}</span
            >
            <pt-custom-tooltip
              tooltipDelay="short"
              [target]="progressOrigin"
              [positions]="tooltipPositions"
            >
              <ng-template ptCustomTooltipContent>
                <div class="flex flex-col gap-1 whitespace-pre-line p-3">
                  <span class="text-xs font-semibold">Step Progress</span>
                  <span class="text-xs opacity-80">
                    {{ progress.visitedCount }} of
                    {{ progress.requiredCount }} items completed
                  </span>
                </div>
              </ng-template>
            </pt-custom-tooltip>
          }
          <mat-icon
            #infoOrigin="cdkOverlayOrigin"
            cdkOverlayOrigin
            class="icon-sm opacity-50"
            >info</mat-icon
          >
          <pt-custom-tooltip
            tooltipDelay="short"
            [target]="infoOrigin"
            [positions]="tooltipPositions"
          >
            <ng-template ptCustomTooltipContent>
              <div class="flex max-w-sm flex-col gap-1 whitespace-pre-line p-3">
                <span class="text-xs font-semibold">{{ step.title }}</span>
                <span class="text-xs opacity-80">
                  <pr-content-view [content]="step.description" />
                </span>
              </div>
            </ng-template>
          </pt-custom-tooltip>
          <pr-practice-setup-step-status
            [dense]="true"
            [status]="step.status"
          />
        </div>

        <div class="flex shrink-0 items-center gap-2">
          <button
            mat-stroked-button
            color="primary"
            (click)="navigateToWizard()"
          >
            <mat-icon>arrow_back</mat-icon>
            Back to Wizard
          </button>
          @if (!stepStore.isComplete()) {
            <div #markCompleteOrigin="cdkOverlayOrigin" cdkOverlayOrigin>
              @if (isManagement() && !stepStore.canComplete()) {
                <button
                  mat-stroked-button
                  class="disabled:opacity-50"
                  color="warn"
                  [disabled]="stepStore.mutating()"
                  (click)="markComplete(true)"
                >
                  @if (stepStore.mutating()) {
                    <mat-icon>hourglass_empty</mat-icon>
                  } @else {
                    <mat-icon>check_circle</mat-icon>
                  }
                  Override Complete
                </button>
              } @else {
                <button
                  mat-raised-button
                  class="disabled:opacity-50"
                  color="primary"
                  [disabled]="stepStore.mutating() || !stepStore.canComplete()"
                  (click)="markComplete()"
                >
                  @if (stepStore.mutating()) {
                    <mat-icon>hourglass_empty</mat-icon>
                  } @else {
                    <mat-icon>check_circle</mat-icon>
                  }
                  Mark Complete
                </button>
              }
            </div>
            <pt-custom-tooltip
              tooltipDelay="short"
              [target]="markCompleteOrigin"
              [positions]="tooltipPositions"
              [disabled]="stepStore.canComplete() && !stepStore.mutating()"
            >
              <ng-template ptCustomTooltipContent>
                <div
                  class="flex max-w-sm flex-col gap-1 whitespace-pre-line p-3"
                >
                  <span class="text-xs font-semibold">{{
                    markCompleteTooltip().title
                  }}</span>
                  @if (markCompleteTooltip().errors.length) {
                    @for (error of markCompleteTooltip().errors; track error) {
                      <span class="text-xs opacity-80">{{ error }}</span>
                    }
                  }
                </div>
              </ng-template>
            </pt-custom-tooltip>
          } @else if (isManagement() && stepStore.canReopen()) {
            <button
              mat-stroked-button
              color="accent"
              (click)="stepStore.reopenStep()"
            >
              <mat-icon>refresh</mat-icon>
              Reopen Step
            </button>
          }
        </div>
      </div>
    </div>
  }
}
